import React from 'react';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { Grid } from '@hbf/dsl';

import { COL_SPACING } from './constants';

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    width: 'inherit',
    [theme.breakpoints.up('md')]: {
      marginLeft: `-${COL_SPACING / 2}px`,
      marginRight: `-${COL_SPACING / 2}px`,
      width: `calc(100% + ${COL_SPACING})px`,
    },
  },
}));

export const ImageGridContainer: React.FC = ({ children }) => {
  const { classes } = useStyles();
  return (
    <Grid
      container
      className={classes.container}
      data-test-locator="Image Grid Container"
    >
      {children}
    </Grid>
  );
};
